<template>
<aside class="left-sidebar" id="appaaa">
            <!-- Sidebar scroll-->

            <div class="scroll-sidebar">
                <!-- Sidebar navigation-->
                <div class="p-15">
                            <a id="compose_mail" class="waves-effect waves-light btn btn-danger d-block" href="javascript: void(0)">Compose</a>
                        </div>
                <nav class="sidebar-nav" >

                    <ul id="sidebarnav" >

                        <li class="nav-small-cap">
                            <i class="mdi mdi-dots-horizontal"></i>
                            <span class="hide-menu">Boites mails</span>
                        </li>
                        <li class="sidebar-item"  :key="i" v-for="(m,i) in info">
                            <a class="sidebar-link has-arrow waves-effect waves-dark active" href="javascript:void(0)" aria-expanded="true">
                                <i class="mdi mdi-inbox"></i>
                                <span class="hide-menu">{{info[i][0].name}}</span>
                            </a>
                            <ul aria-expanded="true" class="collapse  first-level" >
                                <li v-on:click="getmessages(f.folder,i)" class="sidebar-item" :key="f"  v-for="f in info[i][0].folders" :folder="f.folder" :mailbox_name="info[i][0].name">
                                    <a href="#" class="sidebar-link">
                                        <i class="mdi mdi-email"></i>
                                        <span class="hide-menu"   >{{ f.folder }} - {{ f.count }} </span>
                                    </a>
                                </li>

                            </ul>
                        </li>



                    </ul>
                </nav>
                <!-- End Sidebar navigation -->
            </div>
            <!-- End Sidebar scroll-->
        </aside>
</template>

<script>
export default {
  data: function () {
    return{
test:"hhhh"
    }
  },
  methods: {
  getmessages: function (folder,mailbox){
      var link='http://leiko-web.com/mailbox/app_mailbox/get_emails_from_folder.php?folder_name='+folder+'&mailbox_id='+mailbox
    	axios.get(link)
      .then((response)  =>  {
       console.log(response);
      }, (error)  =>  {
        alert(link);
      })
     this.$emit('update_messages_data','hhhhhhhhhh');
  }
  },
  props:['info']

}
</script>

